import { useState } from 'react';
import { useAuth } from '../lib/auth.jsx';

export default function SignIn() {
  const { signIn, signInWith, oauthProviders } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function oauth(provider) {
    setBusy(true); setError(null);
    const { error: err } = await signInWith(provider);
    // On success the page navigates away; only a failure comes back here.
    if (err) { setError(err.message); setBusy(false); }
  }

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    const { error: err } = await signIn(email.trim());
    setBusy(false);
    if (err) setError(err.message); else setSent(true);
  }

  if (sent) {
    return (
      <main className="app-shell stack">
        <p className="eyebrow">Fortunaut</p>
        <h1>Check your email</h1>
        <p className="muted">We sent a sign-in link to {email}. It works once and expires in an hour.</p>
        <button className="quiet" onClick={() => setSent(false)}>Use a different address</button>
      </main>
    );
  }

  return (
    <main className="app-shell stack">
      <p className="eyebrow">Fortunaut</p>
      <h1>Sign in</h1>
      <p className="muted">
        Grown-ups sign in. Kids don’t need an account — they pick their avatar on your device.
      </p>
      {oauthProviders.length > 0 && (
        <div className="card stack">
          {oauthProviders.includes('google') && (
            <button className="primary" type="button" disabled={busy} onClick={() => oauth('google')}>
              Continue with Google
            </button>
          )}
          {oauthProviders.includes('apple') && (
            <button className="primary" type="button" disabled={busy} onClick={() => oauth('apple')}>
              Continue with Apple
            </button>
          )}
          <p className="small muted">Or use an email link below.</p>
        </div>
      )}
      <form className="card stack" onSubmit={submit}>
        <label>
          Your email
          <input
            type="email" required autoComplete="email" value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
          />
        </label>
        {error && <p className="notice error">{error}</p>}
        <button className="primary" type="submit" disabled={busy || !email.trim()}>
          {busy ? 'Sending…' : 'Email me a link'}
        </button>
        <p className="small muted">No password to share, forget, or find on the fridge.</p>
      </form>
    </main>
  );
}
